import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { AnimatedSection } from './ui/AnimatedSection';
const faqs = [{
  q: '¿Necesito mucho dinero para empezar?',
  a: 'No, el sistema está diseñado para montos desde $75 USD.'
}, {
  q: '¿Es seguro?',
  a: 'Sí, nos enfocamos en instituciones reguladas y de bajo riesgo.'
}, {
  q: '¿Tengo que dejar de salir con mis amigos?',
  a: 'No, el sistema ajusta tu flujo de caja sin eliminar tu vida social.'
}, {
  q: '¿Cuánto tiempo toma configurarlo?',
  a: 'Menos de 2 horas en total.'
}, {
  q: '¿Sirve para cualquier país?',
  a: 'Sí, los principios de ingeniería financiera son universales.'
}, {
  q: '¿Tengo que saber de matemáticas?',
  a: 'En absoluto, el sistema es lógico y procedimental.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <AnimatedSection className="py-24 bg-navy-800 relative px-4 sm:px-6 lg:px-8" data-id="element-10">
      <div className="max-w-3xl mx-auto" data-id="element-11">
        <h2 className="text-3xl sm:text-4xl font-bold text-center mb-16" data-id="element-12">
          Preguntas Frecuentes
        </h2>

        <div className="space-y-4" data-id="element-13">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <div key={index} className={`border rounded-2xl overflow-hidden transition-colors duration-300 ${isOpen ? 'bg-navy-900 border-gold-400/50' : 'bg-navy-900/50 border-navy-700 hover:border-navy-600'}`} data-id="element-14">
                <button onClick={() => setOpenIndex(isOpen ? null : index)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-gold-400 focus-visible:ring-inset" aria-expanded={isOpen} data-id="element-15">
                  <span className={`text-lg font-medium pr-8 ${isOpen ? 'text-gold-400' : 'text-slate-200'}`} data-id="element-16">
                    {faq.q}
                  </span>
                  <ChevronDown className={`w-5 h-5 shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180 text-gold-400' : 'text-slate-500'}`} data-id="element-17" />
                </button>

                <AnimatePresence data-id="element-18">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} data-id="element-19">
                      <div className="px-6 pb-5 text-slate-400 text-lg" data-id="element-20">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </div>

      {/* Bottom divider */}
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-gold-400/10 to-transparent" data-id="element-21" />
    </AnimatedSection>;
}